<template>
  <div
    class="org-table"
    :class="[options.class ? options.class : '', { 'my-table': table.uuid === currentUserTable.uuid }]"
  >
    <div class="table-header" :class="tableUsers.length ? 'hasguests' : 'noguests'" @click="isOpened = !isOpened">
      <div v-if="table.IS_NOMINEE" class="highlight-nominee">
        <i class="ncurved fa fa-fw fa-star" aria-hidden="true"></i>
      </div>
      <div class="table-number">
        <div class="num">{{ options.group_prefix }}{{ number + 1 }}</div>
      </div>
      <div class="header-top">
        <div class="table-style-icon" v-if="!table.LOGO">
          <div class="table-icon">
            <i class="ar-icon icon-ico_table_users"></i>
          </div>
        </div>
        <div class="table-style-logo" v-if="table.LOGO">
          <div class="table-logo">
            <img class="ico-table-users" :src="table.LOGO" :alt="table.TITLE" />
          </div>
        </div>
      </div>
      <div class="header-base" :class="table.LOGO ? 'haslogo' : ''">
        <div class="name">
          <span v-if="!table.LOGO || table.SHOW_TITLE" class="name-txt">{{ table.TITLE }}</span>
        </div>
        <div v-if="room.SHOW_NUMBERS" class="count">
          <span class="in-count">{{ activeUsersCount }}</span
          ><span class="out-count"> | {{ inactiveUsersCount }}</span>
        </div>
        <div class="exp-head"><i class="fa fa-fw fa-chevron-down"></i></div>
      </div>
    </div>
    <transition name="expand">
      <div
        class="table-content"
        :class="{ 'my-table': table.uuid === currentUserTable.uuid }"
        v-if="isOpened && tableUsers.length"
      >
        <div v-if="table.uuid === currentUserTable.uuid" class="my-table-title">My {{ groupTerminology }}</div>
        <div v-if="tableUsers.length" class="guests">
          <ul class="guest-list">
            <li class="guest" v-for="user in tableUsers" :key="'tableUser-' + user.userUUID">
              <person :person="user" :options="{ company: true, title: true, actions: true }"></person>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";
import { mapGetters } from "vuex";

export default {
  name: "Table",
  components: {
    person: Person
  },
  data() {
    return {
      isOpened: false
    };
  },
  props: {
    table: {
      type: Object,
      required: true
    },
    number: {
      type: Number,
      required: true
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUserTable: "tables/userTable",
      room: "room/activeRoom",
      groupTerminology: "room/groupTerminology"
    }),
    /**
     * Get table users list
     * @return {Object[]}
     */
    tableUsers() {
      return this.$store.getters["tables/tableUsersByAssignments"](this.table.ASSIGNMENTS).sort((a, b) => {
        if (a?.profile.firstName && b?.profile.firstName) {
          return a.profile.firstName.localeCompare(b.profile.firstName);
        } else {
          return a.firstName.localeCompare(b.firstName);
        }
      });
    },
    /**
     * Get active users count
     * @return {Integer}
     */
    activeUsersCount() {
      return this.tableUsers.filter(u => u.isOnline).length;
    },
    /**
     * Get inactive users count
     * @return {Integer}
     */
    inactiveUsersCount() {
      return this.tableUsers.filter(u => !u.isOnline).length;
    }
  },
  methods: {
    /**
     * Open tabs in user area
     * @param tabNames {String[]}
     * @param doScroll {Boolean}
     */
    openTabs(tabNames, doScroll) {
      tabNames.forEach((tab, index) => {
        setTimeout(() => {
          this.$root.$emit("activateTab", tab);
        }, 300 * index);
      });

      if (doScroll) {
        let chatsElement = document.getElementById("people-chat-container");
        chatsElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }
};
</script>
